import React from 'react'
import { useLocation } from 'react-router-dom';
import styles from './ArticleControl.module.scss';
import qs from 'query-string';

import ArticleNav from '../article_nav/ArticleNav';
import ArticleList from '../article_list/ArticleList';
import ArticleWrite from '../article_write/ArticleWrite';
import ArticleView from '../article_view/ArticleView';

const ArticleControl = (props) => {

  const location = useLocation();
  const params = qs.parse(location.search);

  return (
    <div id={styles.wrapper_articleControl}>
      <div id={styles.wrapper_body}>
        <ArticleNav
          title={props.title}
          categories={props.categories}
          categoriesDic={props.categoriesDic}
        />

        {params.command === 'list' &&
          <ArticleList
            title={props.title}
            categories={props.categories}
            categoriesDic={props.categoriesDic}
          />
        }
        {
          (params.command === 'write' || params.command === 'edit') &&
          <ArticleWrite
            title={props.title}
            categories={props.categories}
            categoriesDic={props.categoriesDic}
          />
        }
        {
          params.command === 'view' && 
          <ArticleView
          title={props.title}
          categories={props.categories}
          categoriesDic={props.categoriesDic}
        />
        }

      </div>
    </div>
  )
}

export default ArticleControl